import React from 'react';

import { useAuth } from '../../context/AuthContext';

import ReviewInfo from './ReviewInfo';
import { type CoachReviewInfoCoachFragment } from './__generated-gql-types__/CoachReviewInfo.generated';

interface CoachReviewInfoProps {
  review: CoachReviewInfoCoachFragment;
  onReview: () => void;
  hasReviewed?: boolean;
}

export const CoachReviewInfo: React.FC<CoachReviewInfoProps> = ({
  review,
  onReview,
  hasReviewed = false,
}) => {
  const { currentUser } = useAuth();
  const isLoggedIn = !!currentUser?.applicant;
  const hasBookedWithCoach = !!review.mostRecentOrder;
  const hasReviewedCoach = !!review.coachingRelationship?.review || hasReviewed;

  return (
    <ReviewInfo
      reviewTotal={review.reviewTotal}
      averageReviewRate={review.averageReviewRate}
      averageKnowledgeReviewRate={review.averageKnowledgeReviewRate}
      averageResponsivenessReviewRate={review.averageResponsivenessReviewRate}
      averageSupportivenessReviewRate={review.averageSupportivenessReviewRate}
      averageValueReviewRate={review.averageValueReviewRate}
      onLeaveAReview={onReview}
      showReviewButton={
        isLoggedIn && hasBookedWithCoach ? !hasReviewedCoach : undefined
      }
    />
  );
};
